module.exports = __webpack_public_path__ + "media/images/haircut/cover-desktop@2x-c0a3ddc50ac6026dea31fb47d0822030.jpg";